module.exports = __webpack_public_path__ + "static/media/hangman-1.20c7a983.png";